import React, { FC } from 'react';
import cn from 'classnames'
import { useStore } from 'store'
import { observer } from 'mobx-react'

import styles from './styles.module.scss'

interface IProps {
  title: React.ReactNode,
  subTitle: React.ReactNode
}
export const TitleBottomSection: FC<IProps> = ({ title, subTitle }) =>  {
  return (
    <div className={styles.titleBottomBox}>
      <div className={styles.title}>
        {title}
      </div>
      <div className={styles.subtitle}>
        {subTitle}
      </div>
    </div>
  );
}
